/**
 * Meta Pixel Helper — client-side event tracking utilities
 * 
 * Used to fire standard Meta events (Lead, CompleteRegistration, PageView)
 * with deduplication support for matching browser + server events.
 */

/**
 * Track a standard Meta Pixel event with dedup ID
 * @param {string} eventName - Standard event name (e.g. 'Lead', 'CompleteRegistration', 'PageView')
 * @param {object} params - Optional event parameters
 * @returns {string|null} eventId for CAPI deduplication, or null if fbq unavailable
 */
export function trackMetaEvent(eventName, params = {}) {
  if (typeof window !== 'undefined' && window.fbq) {
    const eventId = crypto.randomUUID();
    window.fbq('track', eventName, params, { eventID: eventId });
    return eventId;
  }
  return null;
}

/**
 * Track PageView on SPA route changes
 * Call this inside a useEffect that watches location changes
 */
export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
}

/**
 * Read _fbc and _fbp cookies set by Meta Pixel
 * Pass these to your backend API calls so the CAPI can use them for dedup
 * @returns {{ fbc: string, fbp: string }}
 */
export function getMetaCookies() {
  if (typeof document === 'undefined') return { fbc: '', fbp: '' };
  
  const cookies = document.cookie.split(';').reduce((acc, c) => {
    const parts = c.trim().split('=');
    if (parts.length === 2) {
      acc[parts[0]] = parts[1];
    }
    return acc;
  }, {});

  return {
    fbc: cookies._fbc || '',
    fbp: cookies._fbp || '',
  };
}
